import { apiFetch, apiRequest } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const templates = createWorkspaceResourceApi('training-templates')

// Workspace-scoped templates
export const trainingTemplatesApi = {
  list: templates.list,
  get: templates.get,
  remove: templates.remove,
  // FormData bodies: no Content-Type, the client lets the browser add the boundary.
  create: templates.create,
  uploadUpdate: (workspaceId, id, formData) =>
    apiFetch(`${templates.path(workspaceId)}/${id}`, { method: 'POST', body: formData }),
  update: templates.update,
  /** Resolves the full response (Blob in `data`). */
  downloadPresentation: (workspaceId, id) =>
    apiRequest(`${templates.path(workspaceId)}/${id}/presentation`, {
      responseType: 'blob',
      ignoreGlobalCatch: true,
    }),
  regeneratePresentation: (workspaceId, id) => templates.action(workspaceId, id, 'presentation'),
  /** Download any stored upload; `baseURL` is only passed when the URL needs one. */
  fetchUpload: (request) =>
    apiRequest(request.url, {
      ...(request.baseURL !== undefined ? { baseURL: request.baseURL } : {}),
      responseType: 'blob',
      ignoreGlobalCatch: true,
    }),
}

// Global (super admin) catalog
export const adminTrainingTemplatesApi = {
  list: (params = {}) => apiFetch('training-templates', { params }),
  get: (id, { signal } = {}) => apiFetch(`training-templates/${id}`, { signal }),
  create: (payload) => apiFetch('training-templates', { method: 'POST', body: payload }),
  uploadUpdate: (id, formData) =>
    apiFetch(`training-templates/${id}`, { method: 'POST', body: formData }),
  update: (id, payload) => apiFetch(`training-templates/${id}`, { method: 'PUT', body: payload }),
  remove: (id) => apiFetch(`training-templates/${id}`, { method: 'DELETE' }),
  assign: (id, workspaceIds) =>
    apiFetch(`training-templates/${id}/assign`, { method: 'POST', body: { workspace_ids: workspaceIds } }),
}
